'use client'
import NextLink from 'next/link'
import { ChevronRightIcon } from '@chakra-ui/icons'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  chakra,
} from '@chakra-ui/react'
import { ComponentProps } from '@/baseComponents'

export interface BreadCrumbProps extends ComponentProps {
  items: PageHierarchyNodeInfo[]
}

/**
 * Represents a wrapper around Chakra's Image.
 * @param imageSrc - Source of image to load
 * @returns MediaImage
 */

export default chakra(BreadcrumbComponent)
export function BreadcrumbComponent({
  items,
  theme = 'brand',
  ...props
}: BreadCrumbProps) {
  return (
    <>
      <Breadcrumb
        color={`${theme}.dark`}
        fontSize='sm'
        separator={<ChevronRightIcon />}
        {...props}
      >
        {items?.map((item, index) => {
          const href = `${item.path}`
          const isCurrentPage: boolean = index === items.length - 1
          return (
            <BreadcrumbItem key={index} isCurrentPage={isCurrentPage}>
              <BreadcrumbLink
                href={href}
                as={isCurrentPage ? undefined : NextLink}
              >
                {item.displayTitle}
              </BreadcrumbLink>
            </BreadcrumbItem>
          )
        })}
      </Breadcrumb>
    </>
  )
}
